/*eslint react-hooks/exhaustive-deps: "off"*/

import classnames from 'classnames';
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useProcessRules from 'src/hooks/useProcessRules';
import CustomErrorMessage from './CustomErrorMessage';

const InputDate = ({ input }) => {
  const methods = useFormContext();
  const { control, formState: { errors } } = methods;

  const { loading, processValidations } = useProcessRules(input);

  const setter = (fn) => ({ value }) => {
    try {
      const newValue = moment(value).format('DD/MM/yyyy');
      fn(newValue);
    } catch (e) { }
  };

  return (
    <React.Fragment>
      <span className="p-float-label">
        <Controller
          name={input.name}
          control={control}
          defaultValue={null}
          rules={processValidations()}
          render={({ field: { onChange, value } }) => (
            <Calendar
              id={input.name}
              className={classnames({
                'w-100': true,
                'p-invalid': errors[input.name],
              })}
              dateFormat="DD  dd 'de' MM 'de' yy"
              onChange={setter(onChange)}
              //onBlur={setter(onBlur)}
              value={moment(value, 'DD/MM/yyyy').toDate()}
              showSeconds
              onMonthChange={() => { }}
              showButtonBar
              onClearButtonClick={(e) => onChange(null)}
              // locale={spanishCalendar}
              yearNavigator
              monthNavigator
              yearRange="1900:2050"
              //formatOnChange="yyyy-MM-DD"
              disabled={loading}
              showIcon
              readOnlyInput
              maxDate={input.max && moment(input.max, 'yyyy/MM/DD').toDate()}
              minDate={input.min && moment(input.min, 'yyyy/MM/DD').toDate()}

            />
          )}
        />
        <label htmlFor={input.name}>{input.campo}</label>
      </span>

      <CustomErrorMessage name={input.name} />
    </React.Fragment>
  );
};

export default InputDate;
